import { createWebHistory , createRouter } from 'vue-router'

//配置路由规则
const routes=[
	{
        path:'/',
        name:'main',
        component:()=>import('@/components/main.vue'),
	},
    {
        path:'/about-us',
        component:()=>import('@/components/en/AboutUsModal.vue'),
	},
    {
        path:'/sustainableInvesting',
        component:()=>import('@/components/en/SustainableInvestingModal.vue'),
	},
    {
        path:'/news',
        component:()=>import('@/components/en/NewsModal.vue'),
	},
    {
        path:'/insights',
        component:()=>import('@/components/en/InsightsModal.vue'),
	},
    {
        path:'/resources',
        component:()=>import('@/components/en/ResourcesModal.vue'),
	},
    {
        path:'/ourawards',
        component:()=>import('@/components/en/OurAwardModal.vue'),
	},
    {
        path:'/ourhistory',
        component:()=>import('@/components/en/OurHistoryModal.vue'),
	},
    {
        path:'/products/:tabType/:strategie/:category',
        component:()=>import('@/components/en/ProductsModal.vue'),
	},
    {
        path:'/privatefunds',
        component:()=>import('@/components/en/PrivatefundsModal.vue'),
	},
    {
        path:'/detail',
        component:()=>import('@/components/common/ProductDetail.vue'),
	},
    {
        path:'/contact-us',
        component:()=>import('@/components/en/ContactUsModal.vue'),
	},
    {
        path:'/privacy-policy',
        component:()=>import('@/components/en/PrivacyPolicy.vue'),
	},
    {
        path:'/copyright-disclaimer',
        component:()=>import('@/components/en/CopyrightDisclaimer.vue'),
	},
    {
        path:'/sitemap',
        component:()=>import('@/components/en/SitemapModal.vue'),
	},
    {
        path:'/subscribe',
        component:()=>import('@/components/en/SubscribeModal.vue'),
	},
    {
        path:'/news-detail',
        component:()=>import('@/components/en/NewsDetail.vue'),
	},
    {
        path:'/news-detail-webpost',
        component:()=>import('@/components/en/NewsDetailWebpost.vue'),
	},
    
    
]
const router = createRouter({
    history:createWebHistory(),
    routes
})
//对路由进行暴露
export default router;